'use client';

import { StateCreator } from 'zustand';

interface CartCalculateState {
    completedShoppingDetail: CartCalculateResult | null;
}

interface CartCalculateActions {
    updateCompletedShoppingDetail: (result: CartCalculateResult) => void;
}

export type CartCalculateSlice = CartCalculateState & CartCalculateActions;

export const createCartCalculateSlice: StateCreator<
    CartCalculateSlice,
    [],
    [],
    CartCalculateSlice
> = (set) => ({
    completedShoppingDetail: null,
    updateCompletedShoppingDetail: (result: CartCalculateResult) => {
        set({ completedShoppingDetail: result });
    },
});
